// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2HRaS","tab":"ProcedureTabs_tab__2Gegn"};